import { configureStore } from '@reduxjs/toolkit';
import receptionBookReducer from '../features/receptionBookSlice';
import impactDataReducer from '../features/impactDataSlice';
import rviewStoreReducer from '../features/rviewStoreSlice';
import trafficConfirmationScreenReducer from '../features/trafficConfirmationScreenSlice';

// Redux Store
export const store = configureStore({
    reducer: {
        receptionBook: receptionBookReducer,
        impactData: impactDataReducer,
        rviewStoreData: rviewStoreReducer,
        trafficConfirmationScreenData: trafficConfirmationScreenReducer,
    }
});

// RootStateとdispatchの型定義
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
